import defaultLocales from 'globals/locales/default';
import { IconBoxProps } from './IconBox/IconBox';

const {
  howItWorks: { iconBoxes: iconBoxesLocales },
} = defaultLocales.inviteCustomersPage;

interface WithLabel {
  label: string;
}

export const iconBoxesProps: Array<IconBoxProps & WithLabel> = [
  {
    iconType: 'invite',
    label: iconBoxesLocales.invite,
  },
  {
    iconType: 'register',
    label: iconBoxesLocales.register,
  },
  {
    iconType: 'receive-report',
    label: iconBoxesLocales.receiveReport,
  },
];
